// extracted by mini-css-extract-plugin
module.exports = {"minimumScreenWidth":"320px","mobileScreenWidth":"600px","root":"style_root__VFEm9","paper":"style_paper__2ulNv"};